import { SeriesCard as BaseSeriesCard } from './series-card'
import { SeriesCardContent } from './series-card-content'
import { SeriesCardImage } from './series-card-image'
import { SeriesCardIntensityBadge } from './series-card-intensity-badge'
import { SeriesCardMeta } from './series-card-meta'
import { SeriesCardTitle } from './series-card-title'
import { X } from 'lucide-react'
import React, { MouseEvent } from 'react'
import { Programme } from 'src/dao/core-dao'

interface SeriesCardDefaultProps {
  series: Programme
  className?: string
  onAction?: () => void
  withDismissControl?: boolean
  onDismissControlClick?: (e: MouseEvent<HTMLButtonElement>) => void
}

export const SeriesCardDefault = ({
  series,
  className,
  onAction,
  withDismissControl,
  onDismissControlClick,
}: SeriesCardDefaultProps): React.ReactElement => {
  const card = (
    <BaseSeriesCard series={series} className={className} onAction={onAction}>
      <SeriesCardImage>
        <SeriesCardContent>
          {series.intensityId && <SeriesCardIntensityBadge />}
          <div className="flex flex-col justify-end flex-1">
            <SeriesCardTitle />
            <SeriesCardMeta />
          </div>
        </SeriesCardContent>
      </SeriesCardImage>
    </BaseSeriesCard>
  )

  if (!withDismissControl) {
    return card
  }

  return (
    <div className="relative h-full">
      <button
        type="button"
        className="absolute top-4 right-4 z-20 p-1 rounded-md text-ivory hover:bg-white/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-ivory"
        aria-label="Cancel series"
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          onDismissControlClick?.(e)
        }}
      >
        <X className="w-6 h-6" strokeWidth={1.5} />
      </button>
      {card}
    </div>
  )
}
